module.exports = __webpack_public_path__ + "img/banner_bg.c7cb5a9d.png";